/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import SelectField from "components/SelectField";

export default function CorporateIncomeTax06() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([]);
  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế thu nhập doanh nghiệp (Mẫu số 06/TNDN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với hoạt động bán toàn bộ doanh nghiệp dưới hình thức chuyển nhượng vốn
                có gắn với bất động sản)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxCalculationPeriod,

    taxpayerName,
    taxpayerId,

    capitalTransfereeName,
    capitalTransfereeTp,
    capitalTransfereeDistrict,
    capitalTransfereeTaxId,
    capitalTransfereeWards,
    capitalTransfereeAddress,

    realEstateTp,
    realEstateDistrict,
    realEstateWards,
    realEstateAddress,

    taxAgentName,
    taxAgentId,

    contractNumber,
    contractDay,
    confirmContractDay,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            1. Bên chuyển nhượng vốn:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerId.name}
            label={taxpayerId.label}
            value={values.taxpayerId}
            error={errors.taxpayerId && touched.taxpayerId}
            success={values.taxpayerId?.toString().length > 0 && !errors.taxpayerId}
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            2. Bên nhận chuyển nhượng vốn:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeName.name}
            label={capitalTransfereeName.label}
            value={values.capitalTransfereeName}
            error={errors.capitalTransfereeName && touched.capitalTransfereeName}
            success={
              values.capitalTransfereeName?.toString().length > 0 && !errors.capitalTransfereeName
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeTaxId.name}
            label={capitalTransfereeTaxId.label}
            value={values.capitalTransfereeTaxId}
            error={errors.capitalTransfereeTaxId && touched.capitalTransfereeTaxId}
            success={
              values.capitalTransfereeTaxId?.toString().length > 0 && !errors.capitalTransfereeTaxId
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeTp.name}
            label={capitalTransfereeTp.label}
            value={values.capitalTransfereeTp}
            error={errors.capitalTransfereeTp && touched.capitalTransfereeTp}
            success={
              values.capitalTransfereeTp?.toString().length > 0 && !errors.capitalTransfereeTp
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeDistrict.name}
            label={capitalTransfereeDistrict.label}
            value={values.capitalTransfereeDistrict}
            error={errors.capitalTransfereeDistrict && touched.capitalTransfereeDistrict}
            success={
              values.capitalTransfereeDistrict?.toString().length > 0 &&
              !errors.capitalTransfereeDistrict
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeWards.name}
            label={capitalTransfereeWards.label}
            value={values.capitalTransfereeWards}
            error={errors.capitalTransfereeWards && touched.capitalTransfereeWards}
            success={
              values.capitalTransfereeWards?.toString().length > 0 && !errors.capitalTransfereeWards
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={capitalTransfereeAddress.name}
            label={capitalTransfereeAddress.label}
            value={values.capitalTransfereeAddress}
            error={errors.capitalTransfereeAddress && touched.capitalTransfereeAddress}
            success={
              values.capitalTransfereeAddress?.toString().length > 0 &&
              !errors.capitalTransfereeAddress
            }
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            [09] Địa chỉ bất động sản được chuyển nhượng:
          </Typography>
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={realEstateTp.name}
            label={realEstateTp.label}
            value={values.realEstateTp}
            error={errors.realEstateTp && touched.realEstateTp}
            success={values.realEstateTp?.toString().length > 0 && !errors.realEstateTp}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={realEstateDistrict.name}
            label={realEstateDistrict.label}
            value={values.realEstateDistrict}
            error={errors.realEstateDistrict && touched.realEstateDistrict}
            success={values.realEstateDistrict?.toString().length > 0 && !errors.realEstateDistrict}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={realEstateWards.name}
            label={realEstateWards.label}
            value={values.realEstateWards}
            error={errors.realEstateWards && touched.realEstateWards}
            success={values.realEstateWards?.toString().length > 0 && !errors.realEstateWards}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={realEstateAddress.name}
            label={realEstateAddress.label}
            value={values.realEstateAddress}
            error={errors.realEstateAddress && touched.realEstateAddress}
            success={values.realEstateAddress?.toString().length > 0 && !errors.realEstateAddress}
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contractNumber.name}
            label={contractNumber.label}
            value={values.contractNumber}
            error={errors.contractNumber && touched.contractNumber}
            success={values.contractNumber?.toString().length > 0 && !errors.contractNumber}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={contractDay.name}
            label={contractDay.label}
            error={errors.contractDay && touched.contractDay}
            success={values.contractDay?.toString().length > 0 && !errors.contractDay}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={confirmContractDay.name}
            label={confirmContractDay.label}
            error={errors.confirmContractDay && touched.confirmContractDay}
            success={values.confirmContractDay?.toString().length > 0 && !errors.confirmContractDay}
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
